import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ApisService } from 'app/services/apis.service';
import { LoadingService } from 'app/services/loading.service';
import { Utils } from 'app/shared/utils';
import { environment } from 'environments/environment.staging';

@Component({
  selector: 'app-verification',
  templateUrl: './verification.component.html',
  styleUrls: ['./verification.component.scss']
})
export class VerificationComponent implements OnInit {
    utils: Utils;
    public sidebarToggleRef = false;
    public searchValue = "";
    public totalRecords = 0; // Total records for pagination
    public page = 1;
    public pageSize = 10;
    public usersData: any = [];
    public players: any = [];
    public tempData: any = [];
  
    // Filters
    public previousRoleFilter = "";
    public previousPlanFilter = "";
    public previousStatusFilter = "";
  public selectedOption = 10;
  public totalRecordsPending = 0;
  public pagePending = 1;
  public pageSizePending = 10;
  public userDataPending: any[] = [];

    @ViewChild("searchInput", { static: false }) searchInput!: ElementRef;
  

  constructor(
    private apiservice : ApisService,
    private router : Router , 
    private loading : LoadingService
  ) { }

  ngOnInit(): void {
    this.fetchUserPending()
  }

  private fetchUserPending(): void {
    this.loading.show()
    const offset = (this.pagePending - 1) * this.pageSizePending;

    this.apiservice
      .getUsereditPending( offset, this.pageSizePending)
      .subscribe({
        next: (response: any) => {
          this.loading.hide()
          if (response?.data?.items && Array.isArray(response.data.items)) {
            this.userDataPending = [...response.data.items];
            this.totalRecordsPending = response.data.total || 0;
          } else {
            this.userDataPending = [];
          }
        },
        error: (err) => {
          this.loading.hide()
          console.error("Error fetching pending users:", err);
          this.userDataPending = [];
        },
      });
  }

  onPageChangePending(event: any) {
    const newPage = event.offset + 1;
    if (this.pagePending === newPage) {
      return;
    }
    this.pagePending = newPage;
    this.fetchUserPending();
    

}

filterUpdate(event?: any, isButtonClick = false): void {
  const searchTerm =
    this.searchInput?.nativeElement?.value?.trim().toLowerCase() || "";

  if (!searchTerm) {
    this.players = [...this.tempData];
    return;
  }

  if (!isButtonClick) {
    this.players = this.tempData.filter((player: any) => {
      return (
        player?.firstName?.toLowerCase().includes(searchTerm) ||
        player?.lastName?.toLowerCase().includes(searchTerm) ||
        player?.number?.toString().includes(searchTerm)
      );
    });
  } else {
    console.log("🔎 Searching for:", searchTerm);


    this.apiservice.searchUsersList(searchTerm, 0, this.pageSize).subscribe({
      next: (response: any) => {
        if (response?.data?.items && Array.isArray(response.data.items)) {
          this.players = [...response.data.items];
          this.tempData = [...this.players];
          this.totalRecords = this.players.length || 0;
        } else {
          console.warn("Unexpected search response format", response);
          this.players = [];
          this.tempData = [];
        }

      },
      error: (error) => {
        console.error("Search API Error:", error);
        this.players = [];
        this.tempData = [];

      },
    });
  }
}

  getFirstImage(postItem): string {
    return postItem?.media
      ? environment.mediaUrl + "/" + postItem.media.url
      : // : "assets/images/logo/logo1.svg";
        "assets/images/goalngo/profile.svg";
  }

  
  /*----------  User profile  ----------*/
  userProfile(id: any) {
    this.router.navigate([`/profile/${id}`]);
  }
}